import React, { Fragment, useEffect, useState } from "react";
import { Alert, AlertTitle, CircularProgress, Container } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { exchangeSsoCode } from "../../../services/LoginService";
import { getSafeRedirect } from "../../../utils/authRedirect";

const getCodeVerifierStorageKey = (provider) => `${provider}_sso_code_verifier`;

const SsoCallback = ({ provider, providerLabel }) => {
  const location = useLocation();
  const [status, setStatus] = useState("loading");
  const [errorMessage, setErrorMessage] = useState("");
  const [responseLogin, setResponseLogin] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");
    const codeVerifierStorageKey = getCodeVerifierStorageKey(provider);

    if (error) {
      sessionStorage.removeItem(codeVerifierStorageKey);
      setErrorMessage(`${providerLabel} sign in could not be completed. Please try again.`);
      setStatus("error");
      return;
    }

    if (!code) {
      sessionStorage.removeItem(codeVerifierStorageKey);
      setErrorMessage(`${providerLabel} sign in did not return an authorization code.`);
      setStatus("error");
      return;
    }

    const exchangeCode = async () => {
      const codeVerifier = sessionStorage.getItem(codeVerifierStorageKey);
      const payload = {
        code,
        state
      };

      if (codeVerifier) {
        payload.codeVerifier = codeVerifier;
      }

      const res = await exchangeSsoCode(provider, payload);

      if (res.userAuthenticated) {
        sessionStorage.removeItem(codeVerifierStorageKey);
        window.localStorage.setItem("user", res.location);
        window.localStorage.setItem("headersSetCookie", res.headersSetCookie);
        window.localStorage.setItem("additionalUserData", JSON.stringify(res.additionalUserData));
        sessionStorage.setItem("siderbarO", true);
        setResponseLogin(res);
        setStatus("success");
      } else {
        sessionStorage.removeItem(codeVerifierStorageKey);
        setErrorMessage(res.errorCode || `${providerLabel} sign in could not be completed. Please try again.`);
        setStatus("error");
      }
    };

    exchangeCode();
  }, [location.search, provider, providerLabel]);

  if (responseLogin && Object.keys(responseLogin).length > 0) {
    return <Navigate to={getSafeRedirect()} replace />;
  }

  if (status === "error") {
    return <Navigate to="/login" state={{ ssoError: errorMessage }} replace />;
  }

  return (
    <Fragment>
      <Container maxWidth="md" className="loginPageContainer">
        <div className="loginPageContainer">
          <Alert severity="info">
            <AlertTitle>Signing in</AlertTitle>
            Completing {providerLabel} sign in.
          </Alert>
          <CircularProgress size={28} className="loginProgress" />
        </div>
      </Container>
    </Fragment>
  );
};

export default SsoCallback;
